import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getHigherEdOrg, getHigherEdOrgs, getHigherEdOrgView, HigherEdOrg, updateHigherEdOrg,
  updateHigherEdOrgContract
} from '@uplift/api';

import { BaseQueryOpts } from '../baseTypes';
import { higherEdQueryKeys } from './higherEdQueryKeys';

export const useHigherEdOrgQuery = (orgId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: higherEdQueryKeys.org(orgId),
    queryFn: async() => {
      const response = await getHigherEdOrg(orgId);

      return response.data;
    },
    ...opts,
  });
};

export const useHigherEdOrgQueryView = (orgId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: higherEdQueryKeys.org(orgId),
    queryFn: async() => {
      const response = await getHigherEdOrgView(orgId);

      return response.data;
    },
    ...opts,
  });
};

export const useHigherEdOrgsQuery = () => {
  return useQuery({
    queryKey: higherEdQueryKeys.orgs(),
    queryFn: async() => {
      const response = await getHigherEdOrgs();

      return response.data;
    },
  });
};

export const useHigherEdOrgNameStateMutation = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: higherEdQueryKeys.org(orgId),
    mutationFn: async(data: HigherEdOrg) => {
      const response = await updateHigherEdOrg(orgId, { name: data.name, stateId: data.state.id });

      return response.data;
    },
    async onSuccess() {
      await queryClient.invalidateQueries(higherEdQueryKeys.org(orgId));
    },
  });
};

export const useHigherEdOrgContractMutation = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: higherEdQueryKeys.org(orgId),
    mutationFn: async(data: HigherEdOrg) => {
      const response = await updateHigherEdOrgContract(orgId, data.contract);

      return response.data;
    },
    async onSuccess() {
      await queryClient.invalidateQueries(higherEdQueryKeys.org(orgId));
    },
  });
};
